module.exports = __webpack_public_path__ + "img/headphones-dark.73c504a1.svg";